'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reflux = require('reflux');

var _reflux2 = _interopRequireDefault(_reflux);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _SpinButton = require('../../generic/SpinButton');

var _SpinButton2 = _interopRequireDefault(_SpinButton);

var _MainStore = require('../../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _CartStore = require('../../../stores/CartStore');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _TipStore = require('../../../stores/TipStore');

var _TipStore2 = _interopRequireDefault(_TipStore);

var _CouponStore = require('../../../stores/CouponStore');

var _CouponStore2 = _interopRequireDefault(_CouponStore);

var _ScheduleScreenStore = require('../../../stores/ScheduleScreenStore');

var _ScheduleScreenStore2 = _interopRequireDefault(_ScheduleScreenStore);

var _CustomChargeStore = require('../../../stores/CustomChargeStore');

var _CustomChargeStore2 = _interopRequireDefault(_CustomChargeStore);

var _AddCard = require('./AddCard');

var _AddCard2 = _interopRequireDefault(_AddCard);

var _PaymentMethodSelect = require('./PaymentMethodSelect');

var _PaymentMethodSelect2 = _interopRequireDefault(_PaymentMethodSelect);

var _CartUtensilsAndNapkins = require('./CartUtensilsAndNapkins');

var _CartUtensilsAndNapkins2 = _interopRequireDefault(_CartUtensilsAndNapkins);

var _CartPriceStructure = require('../CartPriceStructure.jsx');

var _CartPriceStructure2 = _interopRequireDefault(_CartPriceStructure);

var _Api = require('../../../utils/Api');

var _Api2 = _interopRequireDefault(_Api);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _Utility = require('../../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _Actions = require('../../../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _uuid = require('uuid');

var _TipMain = require('../../tip/TipMain');

var _TipMain2 = _interopRequireDefault(_TipMain);

var _RoundUpChargeView = require('../custom-charge/RoundUpChargeView');

var _RoundUpChargeView2 = _interopRequireDefault(_RoundUpChargeView);

var _OptionalChargeView = require('../custom-charge/OptionalChargeView');

var _OptionalChargeView2 = _interopRequireDefault(_OptionalChargeView);

var _LoginBtn = require('./LoginBtn');

var _LoginBtn2 = _interopRequireDefault(_LoginBtn);

var _Constants = require('../../Constants');

var Constants = _interopRequireWildcard(_Constants);

var _SimpleButton = require('../../generic/SimpleButton');

var _SimpleButton2 = _interopRequireDefault(_SimpleButton);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _reactRouterDom = require('react-router-dom');

var _sweetalert = require('sweetalert2');

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var ERROR_MESSAGE = "Some error occurred while placing order! Try Again!";
var PLACE_ORDER = "Place Pick Up Order";
var DEFAULT_DELIVERY_TIP_PERCENTAGE = 20;
var DEFAULT_DINE_IN_TIP_PERCENTAGE = 20;
var PAY_WITH_CARD = "Buy with Card";
var CREATE_ACCOUNT = "Create an account for faster checkout next time.";
var INIT_LOAD_MSG = "Loading payment methods ...";
var SESSION_ERROR_MSG = "Your user session has expired! Please 'Sign Out' and 'Sign In.";
var PHONE_NUMBER_LENGTH = 10;
var USER_ERROR_MSG = "Invalid payment method or missing required user information. Try again!";
// const GUEST_USER_ERR_MSG = "Please provide your name, email, and phone number to complete the order.";

var stripe = null;
var paymentRequest = null;

//wrapper functional component to pass params as props to main file.
function withCartScreenRouter(Component) {
    function ComponentWithCartScreenRouter(props) {
        var history = (0, _reactRouterDom.useHistory)();
        var params = (0, _reactRouterDom.useParams)();
        return _react2.default.createElement(Component, _extends({}, props, { history: history, params: params /* other hooks */ }, {
            params: params

        }));
    }
    return ComponentWithCartScreenRouter;
}

var CartPaymentScreen = (0, _createReactClass2.default)({
    displayName: 'CartPaymentScreen',


    mixins: [_reflux2.default.listenTo(_CartStore2.default, 'onCartStoreChange'), _reflux2.default.listenTo(_TipStore2.default, 'onTipChange'), _reflux2.default.listenTo(_CouponStore2.default, 'onCouponChange'), _reflux2.default.listenTo(_ScheduleScreenStore2.default, 'onScheduleScreenStoreChange')],

    getInitialState: function getInitialState() {
        return {
            guestInfoObj: {
                name: "",
                email: "",
                phoneNumber: "",
                password: "",
                createGuestUserAccount: false
            },
            isLoggedInExistingUser: false,
            loggedInUserObj: {},
            cartBuffer: [],
            orderType: "",
            tip: 0,
            orderInstruction: '',
            isOrderBeingPlaced: false,
            orderButtonText: PLACE_ORDER,
            scheduledDate: _ScheduleScreenStore2.default.getScheduledDate(),
            isOrderTypeTabEnabled: true,
            isDineInEnabled: false,
            payWithCard: true,
            stripePaymentMethod: null,
            showGooglePayBtn: false,
            showApplePayBtn: false,
            // isProcessActive: false,
            isMobile: false,
            orderSuccessObject: {},
            placeOrderText: false,
            addCards: true,
            savedCards: true,
            isCouponApplied: false,
            addCardPaymentMethod: {},
            gPayapplePay: false,
            title: "Please Sign In",
            isPreferCurbSide: false,
            userSession: false,
            onfocus: true,
            paymentMethodLoading: false,
            giftCardCode: "",
            showGiftCards: false,
            errors: {}
        };
    },
    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
        var _this = this;

        var guestInfoObj = this.getGuestUserObj();

        this.setState({
            cartBuffer: _CartStore2.default.getCartItems(),
            orderInstruction: _CartStore2.default.getOrderInstructions(),
            couponCode: _CartStore2.default.getCouponCode(),
            deliveryFee: _CartStore2.default.getDeliveryFeeRounded(2),
            orderType: _CartStore2.default.getOrderType(),
            tip: _CartStore2.default.getTip(),
            tipType: _CartStore2.default.getTipType(),
            tipPercent: _CartStore2.default.getTipPercent(),
            isCouponApplied: _CartStore2.default.getCouponCode() ? true : false,
            isOrderTypeTabEnabled: _MainStore2.default.isLocationForDineInOnly(),
            isDineInEnabled: _MainStore2.default.isDineInEnabled(),
            isMobile: this.props.isMobile,
            guestInfoObj: guestInfoObj
        }, function () {
            // Used for enable the payment view based on the google pay/apple pay or card
            _this.getCurrentUserState();
        });
    },
    componentDidMount: function componentDidMount() {
        var _this2 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var self, routeToMainPage;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            Utils.showSpinner();

                            self = _this2;

                            //route to main screen if cart is empty

                            _context.next = 4;
                            return _this2.handleCartScreenReload();

                        case 4:
                            routeToMainPage = _context.sent;

                            if (!routeToMainPage) {
                                _context.next = 7;
                                break;
                            }

                            return _context.abrupt('return');

                        case 7:

                            // Initialize stripe publishableKey
                            self.stripeInit();

                            // Load the Payment Request Button
                            self.loadStripePaymentRequestButton();

                            // Load the "Google & Apple Pay button onClick function"
                            self.loadPaymentRequestButtonCallBack();

                            //show saved payment method
                            self.getCurrentUserState();

                            setTimeout(function () {
                                Utils.hideSpinner();
                            }, 1000);

                        case 12:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }))();
    },
    handleCartScreenReload: function handleCartScreenReload() {
        var locId = this.props.params.locId;
        var routeToMainScreen = false;
        if (_CartStore2.default.getCartItems().length === 0) {
            var history = this.props.history;

            routeToMainScreen = true;

            // Navigate to Another Component
            history.push({
                pathname: '/location/' + locId
            });

            return routeToMainScreen;
        }

        return routeToMainScreen;
    },
    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {

        if (this.props !== nextProps) {
            var guestInfoObj = this.getGuestUserObj();

            var isUserLoggedIn = false;
            if (!Utils.isEmptyObj(nextProps.loggedInUserObj)) {
                isUserLoggedIn = nextProps.loggedInUserObj.isLoggedInExistingUser;
            }

            this.setState({
                isMobile: nextProps.isMobile,
                guestInfoObj: guestInfoObj,
                isLoggedInExistingUser: isUserLoggedIn,
                loggedInUserObj: nextProps.loggedInUserObj
            });
        }

        if (nextProps.loggedInUserObj !== this.state.loggedInUserObj) {
            this.getCurrentUserState();
        }
    },
    onCartStoreChange: function onCartStoreChange(event, _cart) {
        this.setState({
            cartBuffer: _cart,
            orderType: _CartStore2.default.getOrderType(),
            isPreferCurbSide: _CartStore2.default.getIsPreferCurbsideEnabled(),
            orderButtonText: this.getPlaceOrderButtonText()
        });
    },
    onTipChange: function onTipChange(event, tipObject) {
        this.setState({
            tip: tipObject.tip,
            tipType: tipObject.tipType,
            tipPercent: tipObject.tipPercent
        });
    },
    onCouponChange: function onCouponChange(event, couponObject) {
        if (couponObject.couponCode) {
            this.setState({
                isCouponApplied: true,
                couponCode: couponObject.couponCode,
                tip: _CartStore2.default.getTip(),
                errors: {}
            });
        } else {
            this.setState({
                isCouponApplied: false,
                couponCode: null,
                tip: _CartStore2.default.getTip(),
                errors: {}
            });
        }
    },
    onScheduleScreenStoreChange: function onScheduleScreenStoreChange(event) {
        this.setState({
            scheduledDate: _ScheduleScreenStore2.default.getScheduledDate()
        });
    },


    //check enable and disable tips view
    checkHidePickUpTipValue: function checkHidePickUpTipValue() {

        var hidePickUpTipOptionData = false;
        var activeLocation = _MainStore2.default.getActiveLocation();

        if (!Utils.isEmptyObj(activeLocation) && !Utils.isEmptyObj(activeLocation.locationConfig)) {

            var hidePickUpTip = activeLocation.locationConfig.hidePickUpTip;
            var orderType = this.state.orderType;

            if (hidePickUpTip == true && orderType == "PickUp") {
                return true;
            } else {
                return false;
            }
        }

        return hidePickUpTipOptionData;
    },
    handleSavedCards: function handleSavedCards(status) {
        var _this3 = this;

        this.setState({
            payWithCard: true,
            savedCards: status,
            addCards: !status,
            gPayapplePay: false,
            showGiftCards: false,
            errors: {},
            giftCardCode: "",
            addCardPaymentMethod: {}
        }, function () {
            _this3.resetPaymentMethod();
            _this3.showGpayPlaceOrderBtn(false);
        });
    },
    handlePayWithCard: function handlePayWithCard() {
        var _this4 = this;

        var currentUser = _parse2.default.User.current();
        var isLoggedInExistingUser = false;

        if (!Utils.isEmptyObj(currentUser)) {
            isLoggedInExistingUser = true;
        }

        this.setState({
            payWithCard: true,
            savedCards: isLoggedInExistingUser,
            addCards: !isLoggedInExistingUser,
            isLoggedInExistingUser: isLoggedInExistingUser,
            gPayapplePay: false,
            showGiftCards: false,
            errors: {},
            giftCardCode: "",
            addCardPaymentMethod: {}
        }, function () {
            _this4.resetPaymentMethod();
            _this4.showGpayPlaceOrderBtn(false);
        });
    },
    handleGiftCards: function handleGiftCards() {
        var _this5 = this;

        this.setState({
            payWithCard: false,
            showGiftCards: true,
            savedCards: false,
            addCards: false,
            gPayapplePay: false,
            errors: {},
            giftCardCode: "",
            addCardPaymentMethod: {}
        }, function () {
            _this5.resetPaymentMethod();
            _this5.showGpayPlaceOrderBtn(false);
        });
    },
    handleGiftCardPayments: function handleGiftCardPayments(e) {

        var value = e.target.value;

        //only allow gift cards upto 16 digits.
        if (value.length <= 16) {
            var result = value.replace(/[^A-Z0-9]/ig, "");

            this.setState({
                giftCardCode: result.toUpperCase(),
                errors: {}
            });
        }
    },
    getGuestUserObj: function getGuestUserObj() {

        var guestInfoObj = {};

        //set userInfo
        var guestObj = _CartStore2.default.getGuestUserObject();
        var currentUser = _parse2.default.User.current();

        if (!Utils.isEmptyObj(guestObj) && Utils.isEmptyObj(currentUser)) {
            var name = guestObj.name;
            var phoneNo = guestObj.phoneNumber;

            var email = "";
            if (guestObj.hasOwnProperty("email")) {
                email = guestObj.email;
            }

            var createGuestUserAccount = false;
            if (guestObj.hasOwnProperty("createGuestUserAccount")) {
                createGuestUserAccount = guestObj.createGuestUserAccount;
            }

            var pass = "";
            if (guestObj.hasOwnProperty("password")) {
                pass = guestObj.password;
            }

            guestInfoObj = {
                name: name,
                phoneNumber: phoneNo,
                email: email,
                createGuestUserAccount: createGuestUserAccount,
                password: pass
            };

            return guestInfoObj;
        } else {
            return guestInfoObj;
        }
    },
    getCurrentUserState: function getCurrentUserState() {
        var currentUser = _parse2.default.User.current();

        if (!Utils.isEmptyObj(currentUser)) {
            this.setState({
                savedCards: true,
                addCards: false,
                showGiftCards: false,
                isLoggedInExistingUser: true,
                giftCardCode: "",
                errors: {}
            });
        } else {

            this.setState({
                savedCards: false,
                addCards: true,
                showGiftCards: false,
                isLoggedInExistingUser: false,
                errors: {}
            });
        }
    },
    resetPaymentMethod: function resetPaymentMethod() {
        if (!this.state.savedCards) {
            _Actions2.default.resetPaymentMethod();
        }
    },
    handleGpayApplePay: function handleGpayApplePay() {
        var _this6 = this;

        this.setState({
            gPayapplePay: true,
            payWithCard: false,
            savedCards: false,
            addCards: false,
            showGiftCards: false,
            giftCardCode: "",
            addCardPaymentMethod: {},
            errors: {}
        }, function () {
            _this6.showGpayPlaceOrderBtn(true);
        });
    },
    showGpayPlaceOrderBtn: function showGpayPlaceOrderBtn(status) {
        var payWithGoogleAppleBtn = document.querySelector('.payWithGoogleAppleBtn');
        var payWithCardBtn = document.querySelector('.payWithCardBtn');

        //show google pay button
        if (payWithGoogleAppleBtn) {
            payWithGoogleAppleBtn.style.display = status ? "inline" : "none";
        }

        //show place order button
        if (payWithCardBtn) {
            payWithCardBtn.style.display = status ? "none" : "inline";
        }
    },
    stripeInit: function stripeInit() {

        var stripePublishableKey = _MainStore2.default.getStripePublishableKey();

        // Initialize the stripe key
        stripe = Stripe(stripePublishableKey, {
            apiVersion: "2020-08-27"
        });
    },


    // get the location name
    getTitleName: function getTitleName() {

        var locationDetail = _CartStore2.default.getLocationDetail();

        if (!Utils.isEmptyObj(locationDetail)) {
            return locationDetail.name;
        } else {
            return "Not Provided";
        }
    },
    loadStripePaymentRequestButton: function loadStripePaymentRequestButton() {

        var self = this;
        // Get the Total order amount
        var amountValue = _CartStore2.default.getCartTotalRounded();
        var totalAmount = Math.round(amountValue * 100);

        // get the location name
        var locationName = self.getTitleName();

        // Create the payment request object with order total amount
        paymentRequest = stripe.paymentRequest({
            country: 'US',
            currency: 'usd',
            total: {
                label: locationName,
                amount: totalAmount
            },
            requestPayerName: true,
            requestPayerEmail: true,
            requestPayerPhone: true
            // requestShipping   : true,
        });

        // Init the stripe elements
        var elements = stripe.elements();
        var prButton = elements.create('paymentRequestButton', {
            paymentRequest: paymentRequest
        });

        try {
            // Check the availability of the Payment Request API first.
            paymentRequest.canMakePayment().then(function (result) {
                // default google / apple btn false
                var showApplePayButton = false;
                var showGooglePayButton = false;

                var button = document.getElementById("payment-request-button");
                if (!Utils.isEmptyObj(result)) {
                    // prButton.mount('#payment-request-button');
                    // Attach button click to start payment request
                    button.addEventListener("click", self.initDefaultStateViaGoogleAppleButton);

                    button.style.display = "inline-block";
                    // if applePay=true then hide th Apple button
                    // Show apple button
                    if (result.applePay) {

                        showApplePayButton = true;
                        showGooglePayButton = false;

                        self.handleGpayApplePay();

                        button.querySelector(".googlepay-span").style.display = "none";
                        button.querySelector(".applepay-span").style.display = "inline";
                    } else {

                        button.querySelector(".googlepay-span").style.display = "inline";
                        button.querySelector(".applepay-span").style.display = "none";

                        self.handleGpayApplePay();

                        showApplePayButton = false;
                        showGooglePayButton = true;
                    }

                    self.setState({
                        showGooglePayBtn: showGooglePayButton,
                        showApplePayBtn: showApplePayButton,
                        paymentMethodLoading: true
                    });
                } else {
                    self.setState({
                        paymentMethodLoading: true
                    });
                }
            }).catch(function (error) {
                // This catch block handles errors in the overall promise chain, including canMakePayment.
                console.error("Error checking payment availability: ", error);
                self.setState({
                    paymentMethodLoading: true
                });
                // Handle the error appropriately, e.g., display an error message or log it.
            });
        } catch (error) {
            // This catch block handles synchronous errors in the try block.
            console.error("Error checking payment availability:", error);
            self.setState({
                paymentMethodLoading: true
            });
            // Handle the error appropriately, e.g., display an error message or log it.
        }
    },
    initDefaultStateViaGoogleAppleButton: function initDefaultStateViaGoogleAppleButton(e) {
        var self = this;
        //Show spinner
        Utils.showSpinner();

        // Init the default state
        this.setState({
            errors: {}
        }, function () {
            // Callback function
            self.validateOnAppleGoogleButton(e);
        });
    },
    initDefaultStateViaCard: function initDefaultStateViaCard(e) {
        e.preventDefault();
        var self = this;

        //show spinner
        Utils.showSpinner();
        self.setState({
            errors: {}
            // clickedPayWithCard       : true
        }, function () {
            // Callback function after update state
            self.validateOnPayWithCardButton();
        });
    },
    validateOnAppleGoogleButton: function validateOnAppleGoogleButton(e) {
        var _this7 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            var self, validationStatus;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            self = _this7;
                            _context2.next = 3;
                            return self.validatePlaceOrderData();

                        case 3:
                            validationStatus = _context2.sent;

                            if (validationStatus) {
                                _context2.next = 7;
                                break;
                            }

                            //hide spinner
                            Utils.hideSpinner();

                            // if any error happens then function will not work after that.
                            return _context2.abrupt('return');

                        case 7:

                            // if all validation success then place the order
                            // Place the order
                            self.loadStripePaymentRequestView(e);

                        case 8:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this7);
        }))();
    },
    validatePlaceOrderData: function validatePlaceOrderData() {
        var _this8 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            var self, isDineInEnabled, orderType, scheduleDate, message, isPickupDisable, _validateOpenHour, title, msg, required;

            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            self = _this8;
                            // Check the location open hours for DineIn orderTypes

                            isDineInEnabled = _MainStore2.default.isDineInEnabled();
                            orderType = _CartStore2.default.getOrderType();
                            scheduleDate = _ScheduleScreenStore2.default.getScheduledDate();

                            if (!(_MainStore2.default.isLocationForDineInOnly() && !isDineInEnabled)) {
                                _context3.next = 9;
                                break;
                            }

                            //hide spinner
                            Utils.hideSpinner();

                            message = "Dine-In ordering is disabled.";


                            _sweetalert2.default.fire({
                                title: 'Dine In Not Available',
                                text: message,
                                icon: 'warning',
                                showConfirmButton: false,
                                showCancelButton: true,
                                cancelButtonText: 'Close',
                                customClass: {
                                    cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                                },
                                allowOutsideClick: false
                            });

                            return _context3.abrupt('return', false);

                        case 9:
                            /* check the pickkup ordering is disabled or not
                            *  check the order type is Pickup
                            * */
                            isPickupDisable = _MainStore2.default.isPickUpOrderDisabled();

                            if (!(isPickupDisable && _this8.isPickup())) {
                                _context3.next = 13;
                                break;
                            }

                            _sweetalert2.default.fire({
                                title: 'Pick Up Not Available',
                                text: 'Restaurant does not provide pickup for this location.',
                                icon: 'warning',
                                showConfirmButton: false,
                                showCancelButton: true,
                                cancelButtonText: 'Close',
                                customClass: {
                                    cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                                },
                                allowOutsideClick: false
                            });

                            return _context3.abrupt('return', false);

                        case 13:

                            // If schedule date is selected then check selected scheduled date valid or not
                            // Check current time is exist in the open hours
                            _validateOpenHour = _this8.validateOpenHour(scheduleDate), title = _validateOpenHour.title, msg = _validateOpenHour.msg;

                            if (!msg) {
                                _context3.next = 25;
                                break;
                            }

                            if (!(orderType == Constants.DINEIN)) {
                                _context3.next = 21;
                                break;
                            }

                            //hide spinner
                            Utils.hideSpinner();

                            _sweetalert2.default.fire({
                                title: title,
                                text: msg,
                                icon: 'warning',
                                showConfirmButton: false,
                                showCancelButton: true,
                                cancelButtonText: 'Close',
                                customClass: {
                                    cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                                },
                                allowOutsideClick: false
                            });

                            return _context3.abrupt('return', false);

                        case 21:
                            //hide spinner
                            Utils.hideSpinner();

                            _sweetalert2.default.fire({
                                title: title,
                                text: msg,
                                icon: 'warning',
                                showCancelButton: true,
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'Yes',
                                cancelButtonText: 'No',
                                customClass: {
                                    confirmButton: "bg-styl",
                                    cancelButton: "swal2-confirm custom-btn-outline-primary custom-primary"
                                },
                                allowOutsideClick: false

                            }).then(function (result) {
                                if (result.isConfirmed) {
                                    self.props.callBackParent(true);
                                }
                            });

                            return _context3.abrupt('return', false);

                        case 24:
                            return _context3.abrupt('return', false);

                        case 25:
                            _context3.next = 27;
                            return _this8.validateOrder();

                        case 27:
                            required = _context3.sent;
                            return _context3.abrupt('return', required);

                        case 29:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this8);
        }))();
    },
    validateGiftCardDetails: function validateGiftCardDetails() {
        var self = this;

        var result = this.state.giftCardCode;

        if (this.state.showGiftCards && Utils.isEmpty(result)) {

            var errors = {
                cardErrorMessage: "Your gift code is incomplete."
                // other error messages are not specified, so they will be empty by default
            };

            this.setState({
                errors: errors
            }, function () {
                Constants.scrollToTop('gift-card-container');
            });

            return false;
        } else {
            this.setState({
                errors: {}
            });
        }

        return true;
    },
    validateOrder: function validateOrder() {
        var _this9 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
            var deliveryAddress, orderType, tipAmount, totalAmount, isCurbsidePickup, isDineInEnabled, itemTaxError, errors, utensilsAndNapkins, _errors, _errors2, msg, _errors3, _errors4, vMakeModel, vColor, _errors5, _errors6, serviceLocationData, sl, _errors7, _errors8, _errors9, _errors10;

            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            deliveryAddress = _CartStore2.default.getDeliveryAddress();
                            orderType = _CartStore2.default.getOrderType();
                            tipAmount = _this9.state.tip;
                            totalAmount = _CartStore2.default.getCartTotalRounded(2);
                            isCurbsidePickup = _CartStore2.default.getIsPreferCurbsideEnabled();
                            isDineInEnabled = _MainStore2.default.isDineInEnabled();
                            itemTaxError = _CartStore2.default.getItemTaxError();

                            if (!Utils.isEmpty(orderType)) {
                                _context4.next = 12;
                                break;
                            }

                            Utils.hideSpinner();

                            errors = {
                                cartErrorMessage: "Choose Delivery Address or Choose Pickup option."
                            };


                            _this9.setState({ errors: errors });

                            return _context4.abrupt('return', false);

                        case 12:
                            if (!_this9.isUtensilsAndNapkins()) {
                                _context4.next = 22;
                                break;
                            }

                            // get utensils and napkins value
                            utensilsAndNapkins = _CartStore2.default.getIsUtensilsAndNapkinsEnabled();

                            if (!Utils.isEmpty(utensilsAndNapkins)) {
                                _context4.next = 21;
                                break;
                            }

                            // required.push("Utensils and Napkins");
                            Utils.hideSpinner();

                            _errors = {
                                utensilsError: "Choose preference for Utensils & Napkins."
                                // other error messages are not specified, so they will be empty by default
                            };


                            _this9.setState({
                                errors: _errors
                            }, function () {
                                Constants.scrollToTop('utensils-section');
                            });

                            return _context4.abrupt('return', false);

                        case 21:
                            _this9.setState({
                                errors: {}
                            });

                        case 22:
                            if (!(_this9.state.isCouponApplied && parseFloat(totalAmount) == 0)) {
                                _context4.next = 25;
                                break;
                            }

                            _context4.next = 31;
                            break;

                        case 25:
                            if (!(_this9.state.isLoggedInExistingUser && _CartStore2.default.isPaymentCartMethod() == false && _this9.state.payWithCard && _this9.state.savedCards)) {
                                _context4.next = 31;
                                break;
                            }

                            Constants.scrollToTop('payment-section');

                            Utils.hideSpinner();

                            _errors2 = {
                                cartErrorMessage: "Payment Method Required."
                            };


                            _this9.setState({ errors: _errors2 });

                            return _context4.abrupt('return', false);

                        case 31:
                            if (!(orderType == Constants.DELIVERY)) {
                                _context4.next = 43;
                                break;
                            }

                            if (!Utils.isEmptyObj(deliveryAddress)) {
                                _context4.next = 38;
                                break;
                            }

                            Utils.hideSpinner();
                            msg = "Delivery address is empty.";
                            _errors3 = {
                                cartErrorMessage: msg
                            };


                            _this9.setState({ errors: _errors3 });
                            return _context4.abrupt('return', false);

                        case 38:
                            if (_CartStore2.default.getCartSubTotalWithDiscountAbs() >= _CartStore2.default.getMinimumAmountOrder()) {
                                _context4.next = 43;
                                break;
                            }

                            Utils.hideSpinner();

                            _errors4 = {
                                cartErrorMessage: 'Minimum order value should be $' + _CartStore2.default.getMinimumAmountOrder() + ' for delivery.'
                            };


                            _this9.setState({ errors: _errors4 });

                            return _context4.abrupt('return', false);

                        case 43:
                            if (!(orderType == Constants.PICKUP)) {
                                _context4.next = 57;
                                break;
                            }

                            if (!isCurbsidePickup) {
                                _context4.next = 57;
                                break;
                            }

                            vMakeModel = _CartStore2.default.getOrderVehicleMakeModel();
                            vColor = _CartStore2.default.getOrderVehicleColor();

                            if (!Utils.isEmpty(vColor)) {
                                _context4.next = 52;
                                break;
                            }

                            Utils.hideSpinner();

                            _errors5 = {
                                cartErrorMessage: 'Vehicle Color Required'
                            };


                            _this9.setState({ errors: _errors5 });

                            return _context4.abrupt('return', false);

                        case 52:
                            if (!Utils.isEmpty(vMakeModel)) {
                                _context4.next = 57;
                                break;
                            }

                            Utils.hideSpinner();

                            _errors6 = {
                                cartErrorMessage: 'Vehicle Make & Model Required'
                            };


                            _this9.setState({ errors: _errors6 });

                            return _context4.abrupt('return', false);

                        case 57:
                            if (!(orderType == Constants.DINEIN)) {
                                _context4.next = 72;
                                break;
                            }

                            if (!isDineInEnabled) {
                                _context4.next = 68;
                                break;
                            }

                            serviceLocationData = _CartStore2.default.getDineInServiceLocationData();

                            if (!Utils.isEmpty(serviceLocationData)) {
                                _context4.next = 66;
                                break;
                            }

                            Utils.hideSpinner();
                            sl = _CartStore2.default.getDineInServiceLocation();
                            _errors7 = {
                                cartErrorMessage: sl
                            };


                            _this9.setState({ errors: _errors7 });
                            return _context4.abrupt('return', false);

                        case 66:
                            _context4.next = 72;
                            break;

                        case 68:
                            Utils.hideSpinner();

                            _errors8 = {
                                cartErrorMessage: "Dine-In ordering is disabled."
                            };


                            _this9.setState({ errors: _errors8 });
                            return _context4.abrupt('return', false);

                        case 72:
                            if (!(tipAmount < 0)) {
                                _context4.next = 77;
                                break;
                            }

                            Utils.hideSpinner();

                            _errors9 = {
                                cartErrorMessage: "Tip value must be positive."
                            };


                            _this9.setState({ errors: _errors9 });
                            return _context4.abrupt('return', false);

                        case 77:
                            if (!itemTaxError) {
                                _context4.next = 82;
                                break;
                            }

                            Utils.hideSpinner();

                            _errors10 = {
                                cartErrorMessage: "Location tax configuration is incorrect. Please let the restaurant or email support@freshbytes.io"
                            };


                            _this9.setState({ errors: _errors10 });
                            return _context4.abrupt('return', false);

                        case 82:
                            return _context4.abrupt('return', true);

                        case 83:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this9);
        }))();
    },
    validateOpenHour: function validateOpenHour(scheduledDate) {

        var desiredDate = null;
        if (scheduledDate) {
            desiredDate = new Date(scheduledDate.getTime());
        } else {
            // get date time based on the location
            var dateTime = _MainStore2.default.getCurrentDateTime();
            desiredDate = dateTime;
        }
        var msg = null;
        var title = "Do you want to schedule this order ?";
        /*
        * activeLocationOpenHours should return the openHours corresponding to the selected day
        * */
        var orderType = _CartStore2.default.getOrderType();
        var orderTypeLocationOpenHours = _CartStore2.default.getOnlineOrderingHours();
        var isLocationOrderTypeOpen = Utils.isResturantOpen(orderTypeLocationOpenHours, desiredDate);
        // Get the delivery hours  and open hours then check selected datetime exist in it
        var deliveryOpenHours = "";
        var isLocDeliveryHoursOpen = "";
        if (orderType == Constants.DELIVERY) {
            deliveryOpenHours = _CartStore2.default.getOnlineOrderingHours(orderType);
            isLocDeliveryHoursOpen = Utils.isResturantOpen(deliveryOpenHours, desiredDate);

            if (!isLocationOrderTypeOpen || !isLocDeliveryHoursOpen) {
                msg = "This location is closed for order";

                if (scheduledDate) {
                    msg = msg + ' at scheduled time : ' + Utils.formatTime(scheduledDate) + '. Delivery hours are: ' + Utils.getOpeningHoursStr(deliveryOpenHours, desiredDate);
                    title = "Do you want to re-schedule this order ?";
                } else {
                    msg = msg + ' at this time. Delivery hours are: ' + Utils.getOpeningHoursStr(deliveryOpenHours, desiredDate) + '.';
                }

                return { title: title, msg: msg };
            }
        }
        if (orderType == Constants.DINEIN && !isLocationOrderTypeOpen) {
            msg = "This location is closed right now for order.";
            return { title: title, msg: msg };
        } else {
            if (!isLocationOrderTypeOpen) {
                msg = "This location is closed";
                if (scheduledDate) {
                    msg = msg + ' at scheduled time: ' + Utils.formatTime(desiredDate) + '.';
                    title = "Do you want to re-schedule this order ?";
                } else {
                    msg = msg + ' right now.';
                }

                return { title: title, msg: msg };
            }
        }
        var cartItems = this.state.cartBuffer;
        var len = cartItems.length;
        for (var i = 0; i < len; i++) {
            var cartItem = cartItems[i];
            var actualItem = _CartStore2.default.getActualItem(cartItem.itemObjectId);
            var groupDetail = actualItem.groupDetailPointer;
            // const parentGroup = MainStore.getParentGroup(groupDetail.parentGroup);
            var openHours = _MainStore2.default.getGroupOpenHours(groupDetail, orderType);
            if (!openHours) {
                continue;
            }

            var isGroupOpen = Utils.isResturantOpen(openHours, desiredDate);

            if (!isGroupOpen) {
                msg = 'Item \'' + actualItem.itemName + '\' is not available to order ';
                if (scheduledDate) {
                    msg = msg + ' at scheduled time : ' + Utils.formatTime(scheduledDate) + '. Open hours are: ' + Utils.getOpeningHoursStr(openHours, desiredDate);
                    title = "Do you want to re-schedule this order ?";
                } else {
                    msg = msg + ' at this time. Open hours are: ' + Utils.getOpeningHoursStr(openHours, desiredDate) + '.';
                }

                break;
            }
        }
        return { title: title, msg: msg };
    },
    loadStripePaymentRequestView: function loadStripePaymentRequestView(e) {

        var self = this;
        // Get the location name
        var locationName = self.getTitleName();

        // Get the Order Total amount
        var amountValue1 = _CartStore2.default.getCartTotalRounded();
        var totalAmount1 = Math.round(amountValue1 * 100);

        // Update the Stripe object with updated order amount
        paymentRequest.update({
            total: {
                label: locationName,
                amount: totalAmount1
            }
        });

        // show the google pay or apple pay screen
        paymentRequest.show();
    },
    loadPaymentRequestButtonCallBack: function loadPaymentRequestButtonCallBack() {
        var self = this;
        // Use arrow functions and descriptive variable names
        paymentRequest.on('paymentmethod', function (paymentMethodEvent) {
            self.handlePaymentMethod(paymentMethodEvent);
        });

        paymentRequest.on('cancel', function () {
            // Hide spinner
            Utils.hideSpinner();
        });
    },
    handlePaymentMethod: function handlePaymentMethod(paymentMethodEvent) {
        var self = this;

        // Check if required properties exist and have values
        if (!Utils.isEmptyObj(paymentMethodEvent) && paymentMethodEvent.payerName && paymentMethodEvent.payerEmail && paymentMethodEvent.payerPhone) {
            var payerName = paymentMethodEvent.payerName,
                payerEmail = paymentMethodEvent.payerEmail;

            var formattedNumber = Utils.formatGoogleApplePayPhoneNumber(paymentMethodEvent);

            var guestObj = {};

            // Check if orderType is delivery
            if (self.isDelivery()) {
                var guestUserObj = _CartStore2.default.getGuestUserObject();
                // Use guestInfoObj from store but update the email
                guestObj = _extends({}, guestUserObj, { email: payerEmail });
            } else {
                // Create a new guestInfoObj
                guestObj = self.createGuestInfoObject(payerName, payerEmail, formattedNumber);
            }

            self.setState({
                stripePaymentMethod: paymentMethodEvent,
                guestInfoObj: guestObj
            }, function () {
                self.handlePostStateLogic();
            });
        } else {

            //hide spinner
            Utils.hideSpinner();

            var errors = {
                cartErrorMessage: USER_ERROR_MSG
            };

            self.setState({
                errors: errors
            });
        }
    },
    createGuestInfoObject: function createGuestInfoObject(name, email, phoneNumber) {
        return {
            name: name,
            email: email,
            phoneNumber: phoneNumber,
            password: "FreshBytes",
            createGuestUserAccount: false
        };
    },
    handlePostStateLogic: function handlePostStateLogic() {
        var self = this;
        // Handle logic after setting state
        if (!self.state.isLoggedInExistingUser) {
            var randomEmail = (0, _uuid.v4)().toString().substring(0, 8).replaceAll("-", "") + "@gmail.com";
            var randomPassword = (0, _uuid.v4)();

            var user = {
                name: self.state.guestInfoObj.name,
                email: randomEmail,
                phoneNo: "0000000000",
                username: randomEmail,
                password: randomPassword,
                isGuest: true
            };

            self.submitSignUpForm(user);
        } else {
            self.placeOrder();
        }
    },


    // Check the Stripe Payment Method Exist or not
    isStripePaymentMethodExist: function isStripePaymentMethodExist() {

        var stripePaymentMethod = this.state.stripePaymentMethod;

        if (stripePaymentMethod) {
            var paymentMethod = stripePaymentMethod.paymentMethod;
            if (!Utils.isEmptyObj(paymentMethod) && paymentMethod != null) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    },


    // Check the  Payment Method Exist or not after card details added
    isAddCardMethodExist: function isAddCardMethodExist() {
        var addCardPaymentMethod = this.state.addCardPaymentMethod;
        if (!Utils.isEmptyObj(addCardPaymentMethod)) {
            var paymentMethod = addCardPaymentMethod.paymentMethod;
            if (!Utils.isEmptyObj(paymentMethod) && paymentMethod != null) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    },


    // Handle the Stripe fail or error condition
    handleStripeFailCondition: function handleStripeFailCondition() {
        var self = this;
        //hide Spinner
        Utils.hideSpinner();
        self.logOutGuestUser();
        if (self.isStripePaymentMethodExist()) {
            var stripePaymentMethod = self.state.stripePaymentMethod;

            // Report to the browser that the payment failed, prompting it to
            // re-show the payment interface, or show an error message and close
            // the payment interface.
            stripePaymentMethod.complete('fail');
        }
    },


    // Handle the Stripe success condition
    handleStripeSuccessCondition: function handleStripeSuccessCondition() {
        var self = this;
        if (self.isStripePaymentMethodExist()) {
            var stripePaymentMethod = self.state.stripePaymentMethod;

            // Report to the browser that the payment failed, prompting it to
            // re-show the payment interface, or show an error message and close
            // the payment interface.
            stripePaymentMethod.complete('success');
        }
    },


    /*
    * Check the location utensils and napkins enabled or not
    * Show utensils and napkins option only when order type delivery or pickup
    * */

    isUtensilsAndNapkins: function isUtensilsAndNapkins() {

        var isUtensils = _MainStore2.default.isLocUtensilsAndNapkinsEnabled();

        if (isUtensils && !this.isDineIn()) {
            return true;
        } else {
            return false;
        }
    },
    updateGuestUserInformation: function updateGuestUserInformation() {
        _CartStore2.default.setGuestUserObject(this.state.guestInfoObj);
    },
    handleNameChange: function handleNameChange(event) {
        var _this10 = this;

        this.setState(function (prevState) {
            var updatedGuestInfoObj = _extends({}, prevState.guestInfoObj, {
                name: event.target.value
            });

            return {
                guestInfoObj: updatedGuestInfoObj,
                errors: {},
                disabled: false
            };
        }, function () {
            _this10.updateGuestUserInformation();
        });
    },
    handlePhoneNumberChange: function handlePhoneNumberChange(e) {
        var _this11 = this;

        var value = e.target.value;

        var formattedPhoneNumber = Utils.convertStringToPhoneNumberFormat(value);
        // const formattedPhoneNumber = Utils.convertStringToPhoneNumberFormat(value);

        // Update state using functional setState for better concurrency
        this.setState(function (prevState) {
            return {
                guestInfoObj: _extends({}, prevState.guestInfoObj, {
                    phoneNumber: formattedPhoneNumber
                }),
                errors: {},
                disabled: false
            };
        }, function () {
            // Callback function after state is updated
            _this11.updateGuestUserInformation();
        });
    },
    handleEmailChange: function handleEmailChange(event) {
        var _this12 = this;

        this.setState(function (prevState) {
            var updatedGuestInfoObj = _extends({}, prevState.guestInfoObj, {
                email: event.target.value
            });

            return {
                guestInfoObj: updatedGuestInfoObj,
                errors: {},
                disabled: false
            };
        }, function () {
            _this12.updateGuestUserInformation();
        });
    },
    handlePasswordChange: function handlePasswordChange(e) {
        var _this13 = this;

        this.setState(function (prevState) {
            var updatedGuestInfoObj = _extends({}, prevState.guestInfoObj, {
                password: e.target.value
            });

            return {
                guestInfoObj: updatedGuestInfoObj,
                errors: {},
                disabled: false
            };
        }, function () {
            _this13.updateGuestUserInformation();
        });
    },
    handleCreateAccount: function handleCreateAccount(e) {
        var _this14 = this;

        this.setState(function (prevState) {
            var updatedGuestInfoObj = _extends({}, prevState.guestInfoObj, {
                createGuestUserAccount: e.target.checked,
                password: ""
            });

            return {
                guestInfoObj: updatedGuestInfoObj,
                errors: {},
                disabled: false
            };
        }, function () {
            _this14.updateGuestUserInformation();
        });
    },
    submitSignUpForm: function submitSignUpForm(user) {
        var _this15 = this;

        var self = this;
        var IsTest = _MainStore2.default.isGuestUserIsTest();

        // validate user details
        if (!this.state.gPayapplePay && !this.validateUserDetails()) {
            Utils.hideSpinner();
            Constants.scrollToTop('guest-section');
            return;
        }

        var userObj = new _parse2.default.User({
            username: user.email,
            password: user.password,
            name: user.name,
            phoneNumber: user.phoneNo,
            email: user.email,
            isGuest: user.isGuest,
            isTest: IsTest
        });

        userObj.signUp().then(function (currentUser) {
            //async
            _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var guestInfoObj;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                Utils.updateUserAcl();
                                _Actions2.default.informLoginChange(currentUser);

                                _context5.next = 4;
                                return self.refreshParseUser();

                            case 4:
                                guestInfoObj = _this15.state.guestInfoObj;


                                if (guestInfoObj.createGuestUserAccount) {
                                    self.setState({
                                        userSession: true,
                                        errors: {}
                                        // isProcessActive: false
                                    });
                                } else {
                                    self.setState({
                                        errors: {}
                                        // isProcessActive: false
                                    });
                                }

                                if (_this15.state.gPayapplePay || _this15.state.showGiftCards) {
                                    //if gpay and applepay detected then place order
                                    self.placeOrder();
                                } else {
                                    //if no payment method is detected then add payment method.
                                    _this15.AddPaymentMethodRef && _this15.AddPaymentMethodRef.addPaymentMethodAndPlaceOrder();
                                }

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this15);
            }))();
        }, function (error) {

            var errors = { userError: error.message };

            self.setState({
                errors: errors
                // isProcessActive: false,
            }, function () {
                Utils.hideSpinner();
                Constants.scrollToTop('guest-section');
                self.logOutGuestUser();
            });
        });
    },
    validateUserDetails: function validateUserDetails() {
        var userDetails = this.state.guestInfoObj;
        var name = !Utils.isEmpty(userDetails.name) ? userDetails.name.trim() : userDetails.name;
        var phoneNumber = userDetails.phoneNumber;
        var email = !Utils.isEmpty(userDetails.email) ? userDetails.email.trim() : userDetails.email;
        var password = userDetails.password;
        var createGuestUserAccount = userDetails.createGuestUserAccount;
        var regex = /^[a-zA-Z0-9][a-zA-Z0-9 ]*$/;
        var phoneNo = !Utils.isEmpty(phoneNumber) ? Utils.removeNonNumber(phoneNumber) : phoneNumber;
        var emailRegex = Constants.EMAIlREGEXP;

        if (Utils.isEmptyObj(userDetails)) {

            var errors = {
                userError: "Please enter the user details."
                // other error messages are not specified, so they will be empty by default
            };

            this.setState({ errors: errors });

            return false;
        } else if (Utils.isEmpty(name)) {

            var _errors11 = {
                userError: "Please enter your name."
                // other error messages are not specified, so they will be empty by default
            };

            this.setState({ errors: _errors11 });

            return false;
        } else if (!regex.test(name)) {
            var _errors12 = {
                userError: "Numbers & Special Characters not Allowed like (@ * . # ! $ ^ &)"
                // other error messages are not specified, so they will be empty by default
            };

            this.setState({ errors: _errors12 });
            return false;
        } else if (Utils.isEmpty(phoneNo)) {

            var _errors13 = {
                userError: "Please enter your phone number."
                // other error messages are not specified, so they will be empty by default
            };

            this.setState({ errors: _errors13 });

            return false;
        } else if (phoneNo.length !== PHONE_NUMBER_LENGTH) {

            var _errors14 = {
                userError: "Phone number must be of 10 digits."
            };

            this.setState({ errors: _errors14 });

            return false;
        } else if (Utils.isEmpty(email)) {

            var _errors15 = {
                userError: "Please enter your email address."
            };

            this.setState({ errors: _errors15 });

            return false;
        } else if (!emailRegex.test(email)) {

            var _errors16 = {
                userError: "Special characters are not allowed in the email address."
            };

            this.setState({ errors: _errors16 });

            return false;
        } else if (createGuestUserAccount && Utils.isEmpty(password)) {

            var _errors17 = {
                userError: "Please enter your password."
            };

            this.setState({ errors: _errors17 });
            return false;
        }

        // Mutate the userDetails object with the trimmed name
        userDetails.name = !Utils.isEmpty(name) ? name.replaceAll(/\s+/g, ' ') : name;
        userDetails.email = !Utils.isEmpty(email) ? email.replaceAll(/\s+/g, ' ') : name;

        // Set errors here for consistency
        this.setState({
            errors: {},
            // isProcessActive: true,
            guestInfoObj: userDetails
        });

        return true;
    },
    validateCardDetails: function validateCardDetails() {

        if (this.state.addCards) {

            var cardElementContainer = document.getElementById("card-number-element");
            var cardElementEmpty = cardElementContainer.classList.contains('StripeElement--empty');
            var cardElementInValid = cardElementContainer.classList.contains('StripeElement--invalid');

            var cardExpiryContainer = document.getElementById("card-expiry-element");
            var cardExpiryEmpty = cardExpiryContainer.classList.contains('StripeElement--empty');
            var cardExpiryInValid = cardExpiryContainer.classList.contains('StripeElement--invalid');

            var cvvNumContainer = document.getElementById("card-cvc-element");
            var cvvNumEmpty = cvvNumContainer.classList.contains('StripeElement--empty');
            var cvvNumInValid = cvvNumContainer.classList.contains('StripeElement--invalid');

            var zipCodeContainer = document.getElementById("card-postal-element");
            var zipCodeEmpty = zipCodeContainer.classList.contains('StripeElement--empty');
            var zipCodeInValid = zipCodeContainer.classList.contains('StripeElement--invalid');

            if (cardElementEmpty) {
                var errors = {
                    cardErrorMessage: "Your card number is incomplete."
                };

                this.setState({ errors: errors });
                return false;
            }

            if (cardElementInValid) {
                var _errors18 = {
                    cardErrorMessage: "Your card number is invalid."
                };

                this.setState({ errors: _errors18 });
                return false;
            }

            if (cardExpiryEmpty) {
                var _errors19 = {
                    cardErrorMessage: "Your card's expiration date is incomplete."
                };

                this.setState({ errors: _errors19 });
                return false;
            }

            if (cardExpiryInValid) {
                var _errors20 = {
                    cardErrorMessage: "Your card's expiration date is invalid."
                };

                this.setState({ errors: _errors20 });
                return false;
            }

            if (cvvNumEmpty) {
                var _errors21 = {
                    cardErrorMessage: "Your card's security code is incomplete."
                };

                this.setState({ errors: _errors21 });
                return false;
            }

            if (cvvNumInValid) {
                var _errors22 = {
                    cardErrorMessage: "Your card's security code is invalid."
                };

                this.setState({ errors: _errors22 });
                return false;
            }

            if (zipCodeEmpty) {
                var _errors23 = {
                    cardErrorMessage: "Your postal code is incomplete."
                };

                this.setState({ errors: _errors23 });
                return false;
            }

            if (zipCodeInValid) {
                var _errors24 = {
                    cardErrorMessage: "Your postal code is inValid."
                };

                this.setState({ errors: _errors24 });
                return false;
            }
        }

        this.setState({ errors: {} });

        return true;
    },
    checkIfUserExists: function checkIfUserExists() {
        var self = this;
        //Check for existing/guest users
        if (!this.state.isLoggedInExistingUser && !this.state.userSession) {

            var guestInfoObj = this.state.guestInfoObj;
            //create guest user account
            if (guestInfoObj.createGuestUserAccount) {

                var user = {
                    name: this.state.guestInfoObj.name,
                    email: this.state.guestInfoObj.email,
                    phoneNo: this.state.guestInfoObj.phoneNumber,
                    username: this.state.guestInfoObj.email,
                    password: this.state.guestInfoObj.password,
                    isGuest: false
                };

                self.submitSignUpForm(user);
            } else {

                var randomEmail = (0, _uuid.v4)().toString().substring(0, 8).replaceAll("-", "") + "@gmail.com";
                var randomPassword = (0, _uuid.v4)();

                var _user = {
                    name: this.state.guestInfoObj.name,
                    email: randomEmail,
                    phoneNo: "0000000000",
                    username: randomEmail,
                    password: randomPassword,
                    isGuest: true
                };

                self.submitSignUpForm(_user);
            }
        } else {
            self.validateOnPayButton();
        }
    },
    logOutGuestUser: function logOutGuestUser() {
        if (!this.state.isLoggedInExistingUser && !this.state.userSession) {
            var history = this.props.history;

            var locId = "";
            Utils.logOut(history, locId, false);
            // console.log("user loggedOut")
        }
    },
    validateOnPayWithCardButton: function validateOnPayWithCardButton() {
        var _this16 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
            var self, validationStatus;
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            self = _this16;
                            // check the validation

                            _context6.next = 3;
                            return self.validatePlaceOrderData();

                        case 3:
                            validationStatus = _context6.sent;

                            if (validationStatus) {
                                _context6.next = 7;
                                break;
                            }

                            //hide spinner
                            Utils.hideSpinner();
                            // if any error happens then function will not work after
                            return _context6.abrupt('return');

                        case 7:
                            if (!(_this16.state.showGiftCards && !self.validateGiftCardDetails())) {
                                _context6.next = 10;
                                break;
                            }

                            //hide spinner
                            Utils.hideSpinner();
                            // if any error happens then function will not work after
                            return _context6.abrupt('return');

                        case 10:
                            if (self.validateCardDetails()) {
                                _context6.next = 14;
                                break;
                            }

                            //hide spinner
                            Utils.hideSpinner();
                            Constants.scrollToTop('card-section');
                            // if any error happens then function will not work after
                            return _context6.abrupt('return');

                        case 14:

                            //check for existing or guest users
                            self.checkIfUserExists();

                        case 15:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this16);
        }))();
    },
    validateOnPayButton: function validateOnPayButton() {

        var self = this;

        // check if paymentMethod is present.
        if (_CartStore2.default.isPaymentCartMethod()) {
            //place order if paymentMethod is present.
            self.placeOrder();
        } else if (this.state.showGiftCards) {
            //place order if paymentMethod is present.
            self.placeOrder();
        } else {
            //add payment method if paymentMethod is not available.
            this.AddPaymentMethodRef && this.AddPaymentMethodRef.addPaymentMethodAndPlaceOrder();
        }
    },
    refreshParseUser: function refreshParseUser() {
        var _this17 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
            var userSession;
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            userSession = false;
                            _context7.next = 3;
                            return _parse2.default.User.current().fetch().then(function (user) {

                                // silent console log after update the current parse user
                                // console.log(JSON.stringify(user));
                                // console.log("user refreshed")
                                userSession = true;
                            }, function (error) {
                                userSession = false;
                                // silent console log after update the current parse user
                                console.log(JSON.stringify(error));
                                //route to main-screen when there is error with user session.
                                if (error.code === _parse2.default.Error.INVALID_SESSION_TOKEN) {

                                    _sweetalert2.default.fire({
                                        title: "User session expired",
                                        text: SESSION_ERROR_MSG,
                                        icon: 'warning',
                                        showConfirmButton: false,
                                        showCancelButton: true,
                                        cancelButtonText: 'Close',
                                        customClass: {
                                            cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                                        },
                                        allowOutsideClick: false
                                    });

                                    var locId = _this17.props.params.locId;
                                    var router = _this17.props.history;
                                    Utils.logOut(router, locId, true);
                                }
                            });

                        case 3:
                            return _context7.abrupt('return', userSession);

                        case 4:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this17);
        }))();
    },
    placeOrder: function placeOrder() {
        var _this18 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
            var self, currentUser, orderType, activeLocation, giftCardConfig, isUserSessionValid, history, locId, paymentObject, stripePaymentMethod, paymentMethod, _paymentMethod, addCardPaymentMethod, _paymentMethod2, format, dateStringWithTime, utcDateTime, deliveryAddress, isLocationCurbsideEnabled, isPreferCurbsideEnabled, vMakeModel, vColor, curbsidePickup, isDineInEnabled, slData, slTitle, dineInOrder, errors, utensilsAndNapkins, extraInfoJSON, customCharges, itemsToPrep;

            return regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            self = _this18;
                            currentUser = _parse2.default.User.current();
                            orderType = _CartStore2.default.getOrderType();
                            activeLocation = _MainStore2.default.getActiveLocation();
                            giftCardConfig = activeLocation.giftCardConfig;
                            // console.log("isAddCardMethodExist: " + self.isAddCardMethodExist())

                            // check user session before placing order.

                            _context8.next = 7;
                            return self.refreshParseUser();

                        case 7:
                            isUserSessionValid = _context8.sent;

                            if (isUserSessionValid) {
                                _context8.next = 13;
                                break;
                            }

                            //if user session is invalid stop the execution
                            history = _this18.props.history;
                            locId = "";

                            Utils.logOut(history, locId, false);
                            return _context8.abrupt('return');

                        case 13:
                            paymentObject = {
                                "userObjectId": currentUser.id,
                                "customerId": currentUser.get("cus_id"),
                                "locationObjectId": _CartStore2.default.getLocationDetailId(),
                                "itemCount": self.state.cartBuffer.length,
                                "orderOriginatedFrom": "Web",
                                "orderInstructions": _CartStore2.default.getOrderInstructions(),
                                "totalAmount": _CartStore2.default.getCartTotalRounded(2),
                                "subTotal": _CartStore2.default.getCartTotalWithoutTaxRounded(2),
                                "taxes": _CartStore2.default.getTaxedPriceRounded(2),
                                "deliveryFee": _CartStore2.default.getDeliveryFeeRounded(2),
                                "tipAmount": self.state.tip
                            };


                            if (self.isStripePaymentMethodExist()) {
                                stripePaymentMethod = self.state.stripePaymentMethod;
                                paymentMethod = stripePaymentMethod.paymentMethod;

                                paymentObject["paymentMaskedNumber"] = paymentMethod.card.last4;
                                paymentObject["paymentMethodId"] = paymentMethod.id;
                                paymentObject["paymentType"] = "Card";
                            } else if (_CartStore2.default.isPaymentCartMethod()) {
                                _paymentMethod = _CartStore2.default.getPaymentMethod();

                                paymentObject["paymentMaskedNumber"] = _paymentMethod.maskedNumber;
                                paymentObject["paymentMethodId"] = _paymentMethod.paymentMethodId;
                                paymentObject["paymentType"] = "Card";
                            } else if (self.isAddCardMethodExist()) {
                                addCardPaymentMethod = self.state.addCardPaymentMethod;
                                _paymentMethod2 = addCardPaymentMethod.paymentMethod;

                                paymentObject["paymentMaskedNumber"] = _paymentMethod2.card.last4;
                                paymentObject["paymentMethodId"] = _paymentMethod2.id;
                                paymentObject["paymentType"] = "Card";
                            }

                            //when gift card is anabled and payment methos is present.
                            else if (_this18.state.showGiftCards && !Utils.isEmptyObj(giftCardConfig) && giftCardConfig.enable == true) {
                                    paymentObject["giftCardCode"] = _this18.state.giftCardCode;
                                } else {
                                    paymentObject["paymentType"] = "None";
                                }

                            if (self.state.scheduledDate) {

                                // Update default timezone and get date and time
                                _momentTimezone2.default.tz.setDefault();
                                format = 'YYYY/MM/DD HH:mm:ss';
                                dateStringWithTime = (0, _momentTimezone2.default)(_this18.state.scheduledDate).format(format);

                                // update the location based timezone

                                _momentTimezone2.default.tz.setDefault(_MainStore2.default.getLocationTimeZone());
                                // convert date in UTC Timezone
                                utcDateTime = (0, _momentTimezone2.default)(dateStringWithTime, format).tz("UTC").format();


                                paymentObject["scheduledAt"] = Utils.getDateJson(utcDateTime);
                            }

                            if (self.state.isCouponApplied) {
                                // paymentObject["subTotal"]   = CartStore.getCartSubTotalWithDiscountRounded();
                                paymentObject["couponCode"] = _this18.state.couponCode;
                                paymentObject["discountAmount"] = _CartStore2.default.getDiscountAmountRounded(2);
                            }
                            deliveryAddress = _CartStore2.default.getDeliveryAddress();

                            if (!(orderType == Constants.DELIVERY)) {
                                _context8.next = 30;
                                break;
                            }

                            paymentObject["orderType"] = "Delivery";
                            paymentObject["deliveryAddLine1"] = deliveryAddress.addLine1;
                            paymentObject["deliveryAddLine2"] = deliveryAddress.addLine2;
                            paymentObject["deliveryZip"] = deliveryAddress.zipCode;
                            paymentObject["deliveryCity"] = deliveryAddress.city;
                            paymentObject["deliveryState"] = deliveryAddress.state;
                            paymentObject["deliveryPhone"] = deliveryAddress.phoneNumber;
                            paymentObject["orderDistance"] = _CartStore2.default.getDeliveryDistance(2);
                            paymentObject["orderDistanceInMeter"] = _CartStore2.default.getDeliveryDistanceInMeter();
                            _context8.next = 48;
                            break;

                        case 30:
                            if (!(orderType == Constants.PICKUP)) {
                                _context8.next = 37;
                                break;
                            }

                            paymentObject["orderType"] = "PickUp";
                            isLocationCurbsideEnabled = _CartStore2.default.isLocationCurbsidePickupEnabled();
                            isPreferCurbsideEnabled = _CartStore2.default.getIsPreferCurbsideEnabled();

                            if (isLocationCurbsideEnabled && isPreferCurbsideEnabled) {
                                vMakeModel = _CartStore2.default.getOrderVehicleMakeModel();
                                vColor = _CartStore2.default.getOrderVehicleColor();
                                curbsidePickup = {
                                    "vMakeModel": vMakeModel,
                                    "vColor": vColor
                                };

                                paymentObject["curbsidePickup"] = curbsidePickup;
                                paymentObject["isPreferCurbsideEnabled"] = isPreferCurbsideEnabled;
                            }
                            _context8.next = 48;
                            break;

                        case 37:
                            if (!(orderType == Constants.DINEIN)) {
                                _context8.next = 43;
                                break;
                            }

                            paymentObject["orderType"] = "DineIn";
                            isDineInEnabled = _MainStore2.default.isDineInEnabled();

                            if (isDineInEnabled) {
                                slData = _CartStore2.default.getDineInServiceLocationData();
                                slTitle = _CartStore2.default.getDineInServiceLocation();
                                dineInOrder = {
                                    "serviceLocation": slTitle,
                                    "slData": slData
                                };

                                paymentObject["dineIn"] = dineInOrder;
                            }
                            _context8.next = 48;
                            break;

                        case 43:
                            //hide spinner
                            Utils.hideSpinner();

                            errors = {
                                cartErrorMessage: "Choose Delivery Address or Choose Pickup option"
                            };


                            self.setState({
                                errors: errors,
                                isOrderBeingPlaced: false
                            });
                            // handle fail condition
                            self.handleStripeFailCondition();
                            return _context8.abrupt('return');

                        case 48:

                            // set the state for Place Order Button
                            self.setState({
                                isOrderBeingPlaced: true
                            });

                            // check if the service fee applied then sending the serviceFee key with value
                            if (_CartStore2.default.isServiceFeeAvailable()) {
                                paymentObject["serviceFee"] = _CartStore2.default.getServiceFeeRounded(2);
                            }

                            /*
                            * Check location utensils and napkins enabled or not
                                */
                            if (self.isUtensilsAndNapkins()) {

                                // get utensils and napkins value
                                utensilsAndNapkins = _CartStore2.default.getIsUtensilsAndNapkinsEnabled();
                                extraInfoJSON = {
                                    "utensilsAndNapkins": utensilsAndNapkins
                                };

                                // created extraInfo column to save value

                                paymentObject["extraInfo"] = extraInfoJSON;
                            }

                            /*
                            * Check the custom charge is configured or not
                            * */

                            if (_CustomChargeStore2.default.isCustomChargeConfigured()) {
                                customCharges = _CartStore2.default.getCustomCharge();


                                if (customCharges.length > 0) {
                                    paymentObject["charge"] = customCharges;
                                }
                            }

                            itemsToPrep = 0;

                            self.state.cartBuffer.forEach(function (cartItem, idx, array) {

                                var itemObjectId = "itemObjectId" + idx;
                                var itemQty = "itemQty" + idx;
                                var itemOptionCategories = "itemOptionCategories" + idx;
                                var itemOrderInst = "itemOrderInst" + idx;

                                var itemOptionCategoriesModified = cartItem.itemOptionCategories.map(function (itemOptionCategory) {
                                    return {
                                        "optionCategoryName": itemOptionCategory.category,
                                        "selectedKeys": itemOptionCategory.selectedKeys
                                    };
                                });

                                itemsToPrep += cartItem.itemQty;
                                paymentObject[itemObjectId] = cartItem.itemObjectId;
                                paymentObject[itemQty] = cartItem.itemQty;
                                paymentObject[itemOptionCategories] = itemOptionCategoriesModified;
                                paymentObject[itemOrderInst] = cartItem.itemOrderInst;
                            });

                            paymentObject["itemsToPrep"] = itemsToPrep;

                            // check the order Payment Intent object exist or not
                            // if yes, then set the order payment object data in paymentObject

                            // we dont use now updatePaymentIntent
                            // if (CartStore.isPaymentMethodObjectAvailable()) {
                            //     let paymentIntentObject = CartStore.getOrderPaymentIntentObject();
                            //     paymentObject["objectId"] = paymentIntentObject.objectId;
                            //     paymentObject["orderNum"] = paymentIntentObject.orderNum;
                            //     paymentObject["paymentIntentId"] = paymentIntentObject.paymentIntentId;
                            // }

                            self.checkAndPlaceOrder(paymentObject);

                        case 56:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this18);
        }))();
    },
    checkAndPlaceOrder: function checkAndPlaceOrder(paymentObject) {
        var self = this;
        var currentUser = _parse2.default.User.current();
        var userId = currentUser.id;
        var sessionToken = currentUser.getSessionToken();
        var isGuest = currentUser.get("isGuest") || false;

        var isLoggedInExistingUser = this.state.isLoggedInExistingUser;

        if (!isLoggedInExistingUser && isGuest) {

            var guestInfoObj = this.state.guestInfoObj || {};

            // Check if guestInfoObj obj is empty the show the error
            if (Utils.isEmptyObj(guestInfoObj)) {
                // Hide spinner and set error message
                Utils.hideSpinner();
                var errorMessage = USER_ERROR_MSG;
                this.setState({ errors: { cartErrorMessage: errorMessage } }, function () {
                    // Log out the guest user
                    self.logOutGuestUser();
                });
                return;
            }

            var name = guestInfoObj.name,
                email = guestInfoObj.email,
                phoneNumber = guestInfoObj.phoneNumber;


            var formattedPhoneNumber = Utils.removeNonNumber(phoneNumber);

            var guestInfoObject = {
                name: name,
                email: email,
                phone: formattedPhoneNumber,
                userType: "guest"
            };

            // Add or update the guestInfo property in paymentObject with the guestInfoObject
            paymentObject.guestInfo = guestInfoObject;
        }

        if (this.state.showGiftCards) {
            this.createGiftCardIntent(userId, sessionToken, paymentObject);
        } else {
            this.createPaymentIntent(userId, sessionToken, paymentObject);
        }
    },
    createGiftCardIntent: function createGiftCardIntent(userId, sessionToken, paymentObject) {

        var self = this;

        // Api.createGiftCardPaymentIntent(userId, sessionToken, paymentObject)
        _Api2.default.payWithGiftCard(userId, sessionToken, paymentObject).then(function (response) {
            if (response.data) {

                var responseData = response.data;
                self.afterSuccessResponse(responseData, paymentObject);
            } else {

                var errors = {
                    cartErrorMessage: ERROR_MESSAGE
                };

                self.setState({
                    errors: errors,
                    isOrderBeingPlaced: false
                }, function () {
                    Utils.hideSpinner();
                    self.logOutGuestUser();
                });
            }
        }, function (error) {

            // check the error and alert the invalid session token
            // Utils.checkErrorIsInvalidSessionToken(error, self.context.router, false);
            var errorMsg = ERROR_MESSAGE;
            if (error && error.responseJSON.error.message) {
                errorMsg = error.responseJSON.error.message;
            }

            var errors = {
                cartErrorMessage: errorMsg
            };

            self.setState({
                errors: errors,
                isOrderBeingPlaced: false
            }, function () {
                Utils.hideSpinner();
                self.logOutGuestUser();
            });
        });
    },
    createPaymentIntent: function createPaymentIntent(userId, sessionToken, paymentObject) {

        var self = this;
        var history = this.props.history;
        var locId = this.props.params.locId;

        _Api2.default.createPaymentIntent(userId, sessionToken, paymentObject).then(function (response) {
            if (response.data) {
                var responseData = response.data;
                // It used for update payment intent
                // self.setPaymentIntentObject(responseData);
                // call the stripe function for payment
                self.stripeConfirmPayment(responseData, paymentObject);
            } else {
                // handle fail condition
                self.handleStripeFailCondition();

                var errors = {
                    cartErrorMessage: ERROR_MESSAGE
                };

                self.setState({
                    errors: errors,
                    isOrderBeingPlaced: false
                }, function () {
                    Utils.hideSpinner();
                });
            }
        }, function (error) {
            // handle fail condition
            self.handleStripeFailCondition();

            // check the error and alert the invalid session token
            Utils.checkErrorIsInvalidSessionToken(error, history, locId, false);
            var errorMsg = ERROR_MESSAGE;
            if (error && error.responseJSON.error.message) {
                errorMsg = error.responseJSON.error.message;
            }

            var errors = {
                cartErrorMessage: errorMsg
            };

            self.setState({
                errors: errors,
                isOrderBeingPlaced: false
            }, function () {
                Utils.hideSpinner();
            });
        });
    },


    // Use for future
    // updatePaymentIntent(userId, sessionToken, paymentObject) {
    //
    //     let self = this;
    //     let history = this.props.history;
    //     let locId = this.props.params.locId;
    //
    //     Api.updatePaymentIntent(userId, sessionToken, paymentObject)
    //         .then(
    //             (response) => {
    //
    //                 if (response.data) {
    //                     let responseData = response.data;
    //                     self.setPaymentIntentObject(responseData);
    //                     self.stripeConfirmPayment(response.data, paymentObject);
    //                 } else {
    //                     // handle fail condition
    //                     self.handleStripeFailCondition();
    //
    //                     let errorMsg = ERROR_MESSAGE;
    //                     self.setState({
    //                         cartErrorMessage: errorMsg,
    //                         isOrderBeingPlaced: false,
    //                         placeOrderText: true
    //                     });
    //                 }
    //             },
    //             (error) => {
    //                 // handle fail condition
    //                 self.handleStripeFailCondition();
    //                 // check the error and alert the invalid session token
    //                 Utils.checkErrorIsInvalidSessionToken(error,history,locId, false);
    //                 let errorMsg = ERROR_MESSAGE;
    //                 if (error && error.responseJSON.error.message) {
    //                     errorMsg = error.responseJSON.error.message;
    //                 }
    //
    //                 self.setState({
    //                     cartErrorMessage: errorMsg,
    //                     isOrderBeingPlaced: false
    //                 });
    //             });
    //
    // },

    //
    // setPaymentIntentObject(orderData) {
    //     let self = this;
    //     if (Utils.isEmptyObj(orderData)) {
    //         Actions.updateOrderPaymentIntentObject({});
    //
    //     } else {
    //         let paymentIntentObject = {
    //             objectId: orderData.orderId,
    //             orderNum: orderData.orderNum,
    //             paymentIntentId: orderData.paymentIntentId
    //         };
    //
    //         Actions.updateOrderPaymentIntentObject(paymentIntentObject);
    //     }
    // },

    stripeConfirmPayment: function stripeConfirmPayment(response, paymentObject) {

        var self = this;

        var clientSecret = response.clientSecret;
        var clonedPaymentMethodId = response.clonedPaymentMethodId;
        var destAccountId = response.destAccountId;

        // Initialize the Stripe
        // stripeAccount = Connected stripe account

        var stripePublishableKey = _MainStore2.default.getStripePublishableKey();

        var stripe = Stripe(stripePublishableKey, {
            stripeAccount: destAccountId
        });

        // call the stripe function for payment
        stripe.confirmCardPayment(clientSecret, {
            payment_method: clonedPaymentMethodId
        }, { handleActions: false }).then(function (result) {

            if (result.error) {
                // handle fail condition
                self.handleStripeFailCondition();

                // check the error and alert the invalid session token
                var errors = {};
                errors["cardErrorMessage"] = ERROR_MESSAGE;

                if (result.error.message) {
                    errors["cardErrorMessage"] = result.error.message;
                }

                self.setState({
                    errors: errors,
                    isOrderBeingPlaced: false
                }, function () {
                    //scroll to error section
                    Constants.scrollToTop('savedCardSection');
                    //hide spinner
                    Utils.hideSpinner();
                });
            } else {
                // handle the stripe success condition
                self.handleStripeSuccessCondition();

                // Check if the PaymentIntent requires any actions and if so let Stripe.js
                // handle the flow. If using an API version older than "2019-02-11" instead
                // instead check for: `paymentIntent.status === "requires_source_action"`.
                if (result.paymentIntent.status === "requires_action") {
                    // Let Stripe.js handle the rest of the payment flow.
                    stripe.confirmCardPayment(clientSecret).then(function (confirmResult) {
                        if (confirmResult.error) {

                            // The payment failed -- ask your customer for a new payment method.
                            var _errors25 = {};
                            _errors25["cardErrorMessage"] = ERROR_MESSAGE;

                            if (confirmResult.error.message) {
                                _errors25["cardErrorMessage"] = confirmResult.error.message;
                            }

                            self.setState({
                                errors: _errors25,
                                isOrderBeingPlaced: false
                            }, function () {
                                //scroll to error section
                                Constants.scrollToTop('savedCardSection');
                                //hide spinner
                                Utils.hideSpinner();
                            });
                        } else {
                            //hide spinner
                            Utils.hideSpinner();

                            // The payment has succeeded.
                            self.afterSuccessResponse(response, paymentObject);
                        }
                    });
                } else {
                    //hide spinner
                    Utils.hideSpinner();
                    // The payment has succeeded.
                    self.afterSuccessResponse(response, paymentObject);
                }
            }
        });
    },
    afterSuccessResponse: function afterSuccessResponse(data, paymentObject) {

        var self = this;

        // let isPreferCurbsideEnabled = false;
        // let sLocationTitle = null;
        // let sLocationData = null;
        // let isDineInEnabled = false;
        // if (paymentObject.orderType == Constants.DINEIN) {
        //
        //     isDineInEnabled = true;
        //     sLocationTitle = paymentObject.dineIn.serviceLocation;
        //     sLocationData = paymentObject.dineIn.slData;
        //
        // } else if (paymentObject.orderType == Constants.PICKUP && paymentObject.isPreferCurbsideEnabled) {
        //
        //     isPreferCurbsideEnabled = paymentObject.isPreferCurbsideEnabled;
        // } else {
        //     // null
        // }

        _Actions2.default.clearScheduleScreenStore(false);
        _Actions2.default.clearCartStore();

        // paymentObject["userInfo"] = this.state.guestInfoObj;
        _CartStore2.default.setCartOrderDetailsObj(data);
        // CartStore.setGuestUserObject({});
        //clear scheduleScreenStore

        // Logout the user
        self.logOutGuestUser();

        //after success route to order-screen
        var activeLocation = _MainStore2.default.getActiveLocation();
        var locationObjectId = activeLocation.objectId;
        var history = this.props.history;

        history.push('/location/' + locationObjectId + '/success');
    },


    // payment method hide show place order button
    hideShowPlaceOrderButton: function hideShowPlaceOrderButton(selectedPaymentMethod) {

        var self = this;

        var payWithCardBtn = true;

        if (selectedPaymentMethod != null && !Utils.isEmptyObj(selectedPaymentMethod)) {

            var paymentMethod = selectedPaymentMethod.paymentMethodId;

            if (paymentMethod == "googlePay" || paymentMethod == "applePay") {

                payWithCardBtn = false;
            } else {
                payWithCardBtn = true;
            }
        }

        self.setState({
            payWithCard: payWithCardBtn,
            isOrderBeingPlaced: false,
            orderButtonText: self.getPlaceOrderButtonText()
        });
    },
    updatePaymentMethod: function updatePaymentMethod(paymentObj) {
        var _this19 = this;

        this.setState({
            addCardPaymentMethod: paymentObj
        }, function () {
            //place order after adding card
            // in guest user
            _this19.placeOrder();
        });
    },
    getPlaceOrderButtonText: function getPlaceOrderButtonText() {

        var totalAmount = _CartStore2.default.getCartTotalRounded();

        var isPreferCurbside = _CartStore2.default.getIsPreferCurbsideEnabled();

        var orderTypeDesc = "";

        var spinText = "";

        if (this.isPickup() && !isPreferCurbside) {
            orderTypeDesc = "Place Pick Up Order";
            spinText = orderTypeDesc + ' - $' + totalAmount + ' ';
            return spinText;
        } else if (this.isPickup() && isPreferCurbside) {
            orderTypeDesc = "Place Curbside Pick Up Order";
            spinText = orderTypeDesc + ' - $' + totalAmount + ' ';
            return spinText;
        } else if (this.isDelivery()) {
            orderTypeDesc = "Place Delivery Order";
            spinText = orderTypeDesc + ' - $' + totalAmount + ' ';
            return spinText;
        } else if (this.isDineIn()) {
            orderTypeDesc = "Place Dine In Order";
            spinText = orderTypeDesc + ' - $' + totalAmount + ' ';
            return spinText;
        }
    },
    isDelivery: function isDelivery() {
        return this.state.orderType == Constants.DELIVERY;
    },
    isPickup: function isPickup() {
        return this.state.orderType == Constants.PICKUP;
    },
    isDineIn: function isDineIn() {
        return this.state.orderType == Constants.DINEIN;
    },
    handleCardErrors: function handleCardErrors(error, status) {

        var session = this.state.userSession;

        if (status == true) {
            session = false;
        }

        var errors = {
            cardErrorMessage: error
        };

        this.setState({
            errors: errors,
            userSession: session
        });
    },
    getAddPaymentMethodRef: function getAddPaymentMethodRef(val) {
        this.AddPaymentMethodRef = val;
    },
    loadPaymentSectionStructure: function loadPaymentSectionStructure() {
        var component = _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                'div',
                { id: 'payment-section', className: 'bg-white rounded shadow-sm p-4 mb-3' },
                _react2.default.createElement(
                    'h6',
                    { className: 'mb-2 cart-heading f16-default' },
                    'How would you like to pay?'
                ),
                this.state.paymentMethodLoading ? _react2.default.createElement(
                    'div',
                    null,
                    $(window).width() < 992 ? this.paymentMethodMobileStructure() : this.loadPaymentMethodScreenWebView()
                ) : _react2.default.createElement(
                    'h4',
                    { className: "color-red  f16-default" },
                    INIT_LOAD_MSG
                )
            ),
            _react2.default.createElement('div', { className: 'pt-2' })
        );

        return component;
    },
    loadPaymentMethodScreenWebView: function loadPaymentMethodScreenWebView() {
        var component = null;
        var activeLocation = _MainStore2.default.getActiveLocation();
        var giftCardConfig = activeLocation.giftCardConfig;
        // let isMobile = this.state.isMobile;
        if (!this.state.isLoggedInExistingUser) {

            component = _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                    'div',
                    { className: '_2gmRl col-sm-12 mobile-margin-bottom' },
                    _react2.default.createElement(
                        'div',
                        { className: '_2YnKK col-sm-3 no-gutter' },
                        _react2.default.createElement(
                            'div',
                            { className: 'mqkMo' },
                            this.loadAppleGpayTab(),
                            _react2.default.createElement(
                                _SimpleButton2.default,
                                {
                                    classNames: this.state.payWithCard ? "_3zAnR _1o1_e " : "_3zAnR",
                                    id: 'btn-social-login',
                                    tabIndex: 17,
                                    onClick: this.handlePayWithCard.bind(this, true)
                                },
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    _react2.default.createElement(
                                        'span',
                                        { className: '' },
                                        _react2.default.createElement('i', { className: 'fa fa-credit-card', 'aria-hidden': 'true' })
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'ml-10 text-secondary-light' },
                                        'Cards'
                                    )
                                )
                            ),
                            this.loadGiftCardTab()
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-9 no-gutter', id: 'card-section' },
                        this.loadPaymentStructure()
                    )
                )
            );
        } else {

            component = _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                    'div',
                    { className: '_2gmRl col-sm-12 mobile-margin-bottom' },
                    _react2.default.createElement(
                        'div',
                        { className: '_2YnKK col-sm-3 no-gutter' },
                        _react2.default.createElement(
                            'div',
                            { className: 'mqkMo' },
                            this.loadAppleGpayTab(),
                            _react2.default.createElement(
                                _SimpleButton2.default,
                                {
                                    classNames: this.state.payWithCard ? "_3zAnR  _1o1_e" : "_3zAnR",
                                    id: 'btn-social-login',
                                    tabIndex: 17,
                                    onClick: this.handlePayWithCard.bind(this, true)
                                },
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    _react2.default.createElement(
                                        'span',
                                        { className: '' },
                                        _react2.default.createElement('i', { className: 'fa fa-credit-card', 'aria-hidden': 'true' })
                                    ),
                                    _react2.default.createElement(
                                        'span',
                                        { className: 'ml-10 text-secondary-light' },
                                        'Cards'
                                    )
                                )
                            ),
                            this.loadGiftCardTab()
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-9 no-gutter', id: 'card-section' },
                        this.loadPaymentStructure()
                    )
                )
            );
        }

        return component;
    },
    paymentMethodMobileStructure: function paymentMethodMobileStructure() {

        var activeLocation = _MainStore2.default.getActiveLocation();
        var giftCardConfig = activeLocation.giftCardConfig;

        var component = _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
                'div',
                {
                    className: 'col-lg-12 col-xs-12 ' + (this.checkHidePickUpTipValue() ? "mobile-margin-bottom" : "")
                },
                _react2.default.createElement(
                    'div',
                    { className: "" },
                    _react2.default.createElement(
                        'div',
                        { className: 'btn-group-loc no-gutter payment-method-container' },
                        this.state.showGooglePayBtn || this.state.showApplePayBtn ? _react2.default.createElement(_LoginBtn2.default, {
                            icon: this.state.showGooglePayBtn ? "fa fa-google" : "fa fa-apple",
                            btnText: 'Pay',
                            spanClassName: 'gpay-icon',
                            btnclassName: this.state.gPayapplePay ? "text-secondary-light tablinks add-payment-active bg-styl font-bold googlepay-span f16-default  ml-10" : "text-secondary-light tablinks googlepay-span add-payment f16-default  ml-10",
                            onClick: this.handleGpayApplePay
                        }) : null,
                        _react2.default.createElement(_LoginBtn2.default, {
                            icon: 'fa fa-credit-card',
                            btnText: 'Cards',
                            spanClassName: 'gpay-icon',
                            btnclassName: this.state.payWithCard ? "tablinks add-payment-active" + " bg-styl font-bold  f16-default ml-10" : "tablinks" + " add-payment ml-5 ml-10 f16-default  ",
                            onClick: this.handlePayWithCard.bind(this, true)
                        }),
                        !Utils.isEmptyObj(giftCardConfig) && giftCardConfig.enable == true ? _react2.default.createElement(_LoginBtn2.default, {
                            icon: 'fa fa-gift',
                            btnText: 'Gift Card',
                            spanClassName: 'gpay-icon',
                            btnclassName: this.state.showGiftCards ? "tablinks" + " add-payment-active bg-styl font-bold  f16-default ml-10" : "tablinks add-payment ml-5 ml-10 f16-default  ",
                            onClick: this.handleGiftCards
                        }) : null
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { id: 'card-section' },
                    this.loadPaymentStructure()
                )
            )
        );

        return component;
    },
    removeAttribute: function removeAttribute() {
        this.setState({
            onfocus: false
        });
    },


    //show gpay/apple on tab when gpay/apple is available
    loadAppleGpayTab: function loadAppleGpayTab() {

        var component = null;

        if (this.state.showGooglePayBtn || this.state.showApplePayBtn) {

            component = _react2.default.createElement(
                _SimpleButton2.default,
                {
                    classNames: this.state.gPayapplePay ? "_3zAnR _1o1_e " : "_3zAnR",
                    id: 'btn-social-login',
                    tabIndex: 15,
                    onClick: this.handleGpayApplePay
                },
                this.state.showGooglePayBtn ? _react2.default.createElement(
                    'span',
                    { className: 'googlepay-span' },
                    _react2.default.createElement('i', { className: 'fa fa-google fa-gpay' })
                ) : null,
                this.state.showApplePayBtn ? _react2.default.createElement(
                    'span',
                    { className: 'applepay-span' },
                    _react2.default.createElement('i', { className: 'fa fa-apple' })
                ) : null,
                _react2.default.createElement(
                    'span',
                    { className: 'ml-10 text-secondary-light' },
                    'Pay'
                )
            );

            return component;
        }
    },


    //show gpay/apple on tab when gpay/apple is available
    loadGiftCardTab: function loadGiftCardTab() {

        var activeLocation = _MainStore2.default.getActiveLocation();
        var giftCardConfig = activeLocation.giftCardConfig;

        var component = null;

        if (!Utils.isEmptyObj(giftCardConfig) && giftCardConfig.enable == true) {

            component = _react2.default.createElement(
                _SimpleButton2.default,
                {
                    classNames: this.state.showGiftCards ? "_3zAnR _1o1_e " : "_3zAnR",
                    id: 'btn-social-login',
                    tabIndex: 26,
                    onClick: this.handleGiftCards
                },
                _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(
                        'span',
                        { className: '' },
                        _react2.default.createElement('i', { className: 'fa fa-gift', 'aria-hidden': 'true' })
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'ml-5 text-secondary-light' },
                        ' Gift Card'
                    )
                )
            );

            return component;
        }
    },
    loadCardSubmitStructure: function loadCardSubmitStructure() {
        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(_AddCard2.default, {
                history: this.props.history,
                locId: this.props.params.locId,
                callBackParent: this.updatePaymentMethod,
                isLoggedInExistingUser: this.state.isLoggedInExistingUser,
                getAddPaymentMethodRef: this.getAddPaymentMethodRef,
                guestInfoObj: this.state.guestInfoObj,
                handleErrors: this.handleCardErrors
            })
        );
    },
    loadErrorStructure: function loadErrorStructure() {
        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            !Utils.isEmpty(this.state.errors["cardErrorMessage"]) ? _react2.default.createElement(
                'div',
                { className: 'alert alert-danger ft-14 mt-15 mr-4 ml-3 mb-0', role: 'alert', id: "savedCardSection" },
                _react2.default.createElement(
                    'i',
                    { className: 'material-icons location-card-ico mr-1 mt-1 ft-20' },
                    'report'
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    'Error:'
                ),
                _react2.default.createElement(
                    'b',
                    { className: "err-box" },
                    this.state.errors["cardErrorMessage"]
                )
            ) : null
        );
    },


    //load payment structure btn
    loadPaymentStructure: function loadPaymentStructure() {
        var component = null;
        if (this.state.payWithCard) {
            var _component = null;

            if (this.state.isLoggedInExistingUser) {
                _component = _react2.default.createElement(
                    'div',
                    { id: "save" },
                    this.loadErrorStructure(),
                    _react2.default.createElement(
                        'div',
                        { className: 'address-select-container' },
                        _react2.default.createElement(
                            'div',
                            { className: 'btn-group btn-group-justified mt-1 w-100' },
                            _react2.default.createElement(
                                'div',
                                { className: 'row w-100 px-1 pr-2 ml-1' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-lg-6 col-6 no-gutter ' },
                                    _react2.default.createElement(_LoginBtn2.default, {
                                        btnText: 'Saved Cards',
                                        btnclassName: this.state.savedCards ? "tablinks credit-tablink credit-tablink-active font-bold cart-header" : "cart-header tablinks credit-tablink",
                                        onClick: this.handleSavedCards.bind(this, true),
                                        tabIndex: 18
                                    })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-lg-6 col-6 no-gutter' },
                                    _react2.default.createElement(_LoginBtn2.default, {
                                        btnText: 'Add New Card',
                                        btnclassName: !this.state.savedCards ? "tablinks credit-tablink credit-tablink-active font-bold cart-header" : " cart-header tablinks credit-tablink",
                                        onClick: this.handleSavedCards.bind(this, false),
                                        tabIndex: 20
                                    })
                                )
                            )
                        )
                    ),
                    this.state.savedCards ? _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_PaymentMethodSelect2.default, {
                            showCardAddStructure: false
                            // modalId={this.props.modalId}
                            , showGooglePayBtn: false,
                            showApplePayBtn: false,
                            callBackParent: this.hideShowPlaceOrderButton,
                            locId: this.props.params.locId,
                            history: this.props.history
                        })
                    ) : null,
                    this.state.addCards ? _react2.default.createElement(
                        'div',
                        { id: "save-card" },
                        this.loadCardSubmitStructure()
                    ) : null
                );
            } else {
                _component = _react2.default.createElement(
                    'div',
                    null,
                    this.loadErrorStructure(),
                    this.loadCardSubmitStructure()
                );
            }

            return _component;
        }

        if (this.state.showGiftCards) {
            component = _react2.default.createElement(
                'div',
                { id: 'gift-card-container' },
                this.loadErrorStructure(),
                _react2.default.createElement(
                    'div',
                    { className: 'border-bottom' },
                    _react2.default.createElement(
                        'h4',
                        { className: 'ml-5 f16-default header-location-default cart-header ft-14 cart-header' },
                        'Enter your gift card code'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { id: 'payment-form' },
                    _react2.default.createElement(
                        'span',
                        { className: '' },
                        _react2.default.createElement('i', { className: 'fa fa-gift fa-2x' })
                    ),
                    _react2.default.createElement('input', {
                        id: "credit-card",
                        className: 'form-control digit',
                        name: 'giftCard',
                        type: "text",
                        placeholder: "Gift Card",
                        onChange: this.handleGiftCardPayments,
                        value: this.state.giftCardCode,
                        maxLength: '16',
                        required: 'required',
                        tabIndex: 27
                    })
                )
            );
            return component;
        }

        if (this.state.showGooglePayBtn || this.state.showApplePayBtn) {
            component = _react2.default.createElement(
                'div',
                null,
                this.loadErrorStructure(),
                this.state.showApplePayBtn || this.state.showGooglePayBtn ? _react2.default.createElement(
                    'div',
                    { className: 'mb-20 mt-20' },
                    this.state.showGooglePayBtn ? _react2.default.createElement(
                        'p',
                        { className: 'googlepay-span px-3 gpay-label mobile-ml-20 ft-14 mt-10 text-secondary-light' },
                        'You are now continuing with ',
                        _react2.default.createElement('i', { className: 'fa fa-google fa-gpay' }),
                        ' Pay'
                    ) : null,
                    this.state.showApplePayBtn ? _react2.default.createElement(
                        'p',
                        { className: 'applepay-span px-3 gpay-label mobile-ml-20 mt-10 text-secondary-light' },
                        'You are now continuing with ',
                        _react2.default.createElement('i', { className: 'fa fa-lg fa-apple' }),
                        ' Pay'
                    ) : null
                ) : _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'span',
                        { className: 'text-secondary-light' },
                        'Sorry no payment method detected'
                    )
                )
            );

            return component;
        }
    },
    render: function render() {
        var _this20 = this;

        var buttonTextMessage = this.getPlaceOrderButtonText();

        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(_CartUtensilsAndNapkins2.default, {
                isMobile: this.props.isMobile,
                errors: this.state.errors
            }),
            this.loadPaymentSectionStructure(),
            !this.state.isLoggedInExistingUser && !this.state.gPayapplePay ? _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { id: 'guest-section',
                        className: 'bg-white rounded shadow-sm p-4 mb-3 '
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'guest-info' },
                        _react2.default.createElement(
                            'h6',
                            { className: 'mb-2 cart-heading f16-default' },
                            'Who\'s the order for?'
                        ),
                        !Utils.isEmpty(this.state.errors["userError"]) ? _react2.default.createElement(
                            'div',
                            { className: 'alert alert-danger alert-userinfo mb-30 ft-14', role: 'alert' },
                            _react2.default.createElement(
                                'i',
                                { className: 'material-icons mr-1 ft-20' },
                                'report'
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: 'sr-only' },
                                'Error:'
                            ),
                            _react2.default.createElement(
                                'b',
                                { className: "err-box" },
                                this.state.errors["userError"]
                            )
                        ) : null
                    ),
                    _react2.default.createElement(
                        'div',
                        {
                            className: 'form-row card p-3 ' + (this.checkHidePickUpTipValue() ? "mobile-margin-bottom" : "")
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group col-md-12' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'name', className: 'ft-14 cart-header required' },
                                'Name'
                            ),
                            _react2.default.createElement('input', { type: 'text',
                                name: 'name',
                                id: 'name',
                                className: 'form-control ',
                                onChange: this.handleNameChange,
                                placeholder: 'Name',
                                value: this.state.guestInfoObj.name || '',
                                required: 'required',
                                tabIndex: 28
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group col-md-12' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'phoneNumber', className: 'ft-14 cart-header required' },
                                'Phone Number'
                            ),
                            _react2.default.createElement('input', {
                                name: 'phoneNumber',
                                id: 'phoneNumber',
                                type: 'tel', required: true,
                                placeholder: 'Phone Number',
                                className: 'form-control',
                                onChange: function onChange(e) {
                                    return _this20.handlePhoneNumberChange(e);
                                },
                                value: this.state.guestInfoObj.phoneNumber || '',
                                tabIndex: 29
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group col-md-12' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'email', className: 'ft-14 cart-header required' },
                                'Email'
                            ),
                            _react2.default.createElement('input', {
                                name: 'email',
                                id: 'email',
                                type: 'text',
                                className: 'form-control',
                                placeholder: 'Email',
                                onChange: this.handleEmailChange,
                                value: this.state.guestInfoObj.email || '',
                                required: 'required',
                                tabIndex: 30
                            })
                        ),
                        this.state.guestInfoObj.createGuestUserAccount ? _react2.default.createElement(
                            'div',
                            { className: 'form-group col-md-12' },
                            _react2.default.createElement(
                                'label',
                                { className: 'ft-14 cart-header required' },
                                'Password'
                            ),
                            _react2.default.createElement('input', {
                                name: 'pwd',
                                type: 'password'
                                // readOnly={this.state.onfocus}
                                , className: 'form-control',
                                placeholder: 'Password',
                                onChange: this.handlePasswordChange,
                                value: this.state.guestInfoObj.password || ''
                                // onFocus={this.removeAttribute}
                                , autoComplete: 'current-password',
                                required: 'required',
                                tabIndex: 31
                                // tabIndex={9}
                                // required
                            })
                        ) : null,
                        !this.state.isLoggedInExistingUser ? _react2.default.createElement(
                            'div',
                            { className: 'form-group col-md-12 mb-2 mt-1 cart-checkout ' },
                            _react2.default.createElement(
                                'label',
                                { className: "container-checkbox" },
                                _react2.default.createElement('input', { type: 'checkbox',
                                    checked: this.state.guestInfoObj.createGuestUserAccount || '',
                                    onChange: this.handleCreateAccount,
                                    tabIndex: 32
                                }),
                                _react2.default.createElement('span', { className: 'checkmark' })
                            ),
                            _react2.default.createElement(
                                'label',
                                {
                                    className: 'mb-0 create-account' },
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    CREATE_ACCOUNT
                                )
                            ),
                            _react2.default.createElement('span', { className: 'clearfix' })
                        ) : null
                    )
                ),
                _react2.default.createElement('div', { className: 'pt-2' })
            ) : null,
            _react2.default.createElement(
                'div',
                { className: 'bg-white rounded shadow-sm p-4 mb-3' },
                !this.checkHidePickUpTipValue() ? _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    _react2.default.createElement(_TipMain2.default, {
                        tip: this.state.tip,
                        tipType: this.state.tipType,
                        tipPercent: this.state.tipPercent,
                        isMobile: this.state.isMobile
                    })
                ) : null,
                _react2.default.createElement(_OptionalChargeView2.default, {
                    orderType: this.state.orderType,
                    curbsidePickUp: _CartStore2.default.getIsPreferCurbsideEnabled(),
                    isMobile: this.state.isMobile
                }),
                _react2.default.createElement('span', { className: 'clearfix' }),
                _react2.default.createElement(_RoundUpChargeView2.default, {
                    orderType: this.state.orderType,
                    isMobile: this.state.isMobile
                }),
                _react2.default.createElement('span', { className: 'clearfix' }),
                this.state.isMobile ? _react2.default.createElement(_CartPriceStructure2.default, {
                    orderType: this.state.orderType,
                    isLoggedInExistingUser: this.props.isLoggedInExistingUser,
                    isMobile: this.state.isMobile,
                    locId: this.props.params.locId,
                    history: this.props.history
                }) : null
            ),
            _react2.default.createElement('div', { className: 'pt-2' }),
            _react2.default.createElement(
                'div',
                { className: 'bg-white rounded shadow-sm p-4' },
                _react2.default.createElement(
                    'div',
                    { className: 'form-group' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-xs-12 no-gutter mb-5' },
                        _react2.default.createElement(
                            'span',
                            { className: 'chk-bx-lbl ft-14 text-secondary-light' },
                            'By placing an order, you are agreeing to the ',
                            _react2.default.createElement(
                                'a',
                                { href: 'http://www.freshbytes.io/terms', tabIndex: 52,
                                    target: '_blank' },
                                'Terms of Service'
                            ),
                            ' and ',
                            _react2.default.createElement(
                                'a',
                                { href: 'http://www.freshbytes.io/privacy', tabIndex: 53,
                                    target: '_blank' },
                                'Privacy Policy'
                            ),
                            ' of FreshBytes.'
                        )
                    )
                ),
                !Utils.isEmpty(this.state.errors["cartErrorMessage"]) ? _react2.default.createElement(
                    'div',
                    { className: 'alert alert-danger mt-10', role: 'alert' },
                    _react2.default.createElement(
                        'i',
                        { className: 'material-icons mr-1 ft-20' },
                        'report'
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'sr-only' },
                        'Error:'
                    ),
                    _react2.default.createElement(
                        'b',
                        { className: "err-box" },
                        this.state.errors["cartErrorMessage"]
                    )
                ) : null,
                _react2.default.createElement(
                    'div',
                    { className: 'payWithGoogleAppleBtn', style: { display: "none" } },
                    _react2.default.createElement(
                        'button',
                        { type: 'button', className: 'btn btn-sm themebtn-google-apple font-weight-bold w-100 ft-18 pt-2 pb-2',
                            id: 'payment-request-button',
                            tabIndex: 16
                        },
                        _react2.default.createElement(
                            'span',
                            { className: 'googlepay-span' },
                            'Buy with  ',
                            _react2.default.createElement('i', { className: 'fa fa-google fa-gpay fa-sm', alt: '' }),
                            ' Pay - $',
                            _CartStore2.default.getCartTotalRounded()
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'applepay-span', style: { display: "none" } },
                            'Buy with ',
                            _react2.default.createElement('i', { className: 'fa fa-sm fa-apple', alt: '' }),
                            ' Pay - $',
                            _CartStore2.default.getCartTotalRounded()
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'payWithCardBtn', id: "place-orderBtn" },
                    _react2.default.createElement(_SpinButton2.default, {
                        classNames: 'btn btn-sm btn-styl font-weight-bold w-100 ft-18 pt-2 pb-2',
                        buttonText: buttonTextMessage,
                        spinText: "Placing Order...",
                        showSpinner: false,
                        whenClicked: this.initDefaultStateViaCard,
                        showIcon: false,
                        tabIndex: 54
                    })
                )
            )
        );
    }
});

//create highter order component.
var HOC_CART_SCREEN = withCartScreenRouter(CartPaymentScreen);
exports.default = HOC_CART_SCREEN;


//////////////////
// WEBPACK FOOTER
// ./src/components/cart-view/cart-left/CartPaymentScreen.jsx
// module id = 572
// module chunks = 0